<script setup lang="ts">
const props = defineProps<{
    title: string,
    desc: string,
    items: {
        title: string,
        desc: string,
        path: string,
        icon: string,
        img: string,
    }[]
}>();

const activeIndex = ref<number>(0);
function handleOpenCard(index: number) {
  activeIndex.value = index;
};
</script>

<template>
    <SectionsBase id="related-products" class="bg-gray-100">
      <div class="container">
        <ChipsDivider>محصولات‌ مرتبط</ChipsDivider>
        <h2>{{ props.title }}</h2>
        <p class="text-body1-semibold text-gray-400 text-center my-6">{{ props.desc }}</p>
        <DevicesMobile>
          <div class="w-full flex flex-col mt-10 gap-6">
            <div
              v-for="item in props.items"
              :key="item.title"
              class="w-full border border-gray-300 p-1.25 rounded-[20px]"
            >
              <div class="w-full bg-white rounded-xl p-6">
                <div class="w-full flex items-center gap-2.5">
                  <Icon :name="item.icon" size="24" class="text-primary-600" />
                  <span class="h4">{{ item.title }}</span>
                </div>
                <p v-html="item.desc" class="text-body2 text-gray-400 mt-4" />
                <Button
                  v-if="item.path"
                  type="Thirdly"
                  :append-icon="{ name: 'solar:round-alt-arrow-left-bold' }"
                  link
                  :to="item.path" 
                  class="mr-4 mt-2"
                >
                  آشنایی بیشتر
                </Button>
                <NuxtImg 
                  :src="item.img"
                  :alt="item.title"
                  loading="lazy"
                  class="w-full shadow-gray-m rounded-3xl"
                />
              </div>
            </div>            
          </div>
        </DevicesMobile>

        <DevicesDesktop>
          <div class="w-full flex-center mt-15 mb-5 gap-2.5 overflow-hidden">
            <div
              v-for="item, index in props.items"
              :key="item.title"
              ref="cards"
              class="w-75 h-92.5 border border-gray-300 p-1.25 rounded-[20px] overflow-hidden transition-all duration-800"
              :class="activeIndex === index && 'w-150'"
              @mouseover="handleOpenCard(index)"
            >
              <div class="w-full h-full flex justify-end bg-white rounded-xl p-6">
                <div
                  class="h-full grid grid-cols-[0fr] transition-all duration-800 [&>div]:overflow-hidden"
                  :class="activeIndex === index && 'grid-cols-[1fr] ml-10'"
                >
                  <div class="flex flex-col justify-center">
                    <NuxtImg 
                      :src="item.img"
                      :alt="item.title"
                      class="min-w-60 w-60 rounded-3xl"
                      loading="lazy"
                    />
                  </div>
                </div>
                <div class="w-60 min-w-60 flex flex-col justify-between items-start">
                  <Icon :name="item.icon" size="32" class="text-primary-600" />
                  <span class="h4">{{ item.title }}</span>
                  <p v-html="item.desc" class="text-body1 text-gray-400" />
                  <Button
                    v-if="item.path"
                    type="Thirdly"
                    :append-icon="{ name: 'solar:round-alt-arrow-left-bold' }"
                    link
                    :to="item.path" 
                  >
                    آشنایی بیشتر
                  </Button>
                  <div v-else class="h-10" />
                </div>
              </div>
            </div>
          </div>
        </DevicesDesktop>
      </div>
    </SectionsBase>
</template>